import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { TextButton } from "../buttons/CommonButton";
import PropTypes from "prop-types";

const DialogContainer = styled.div`
	position: fixed;
	z-index: 12;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	overflow: auto;
	background-color: rgba(0, 0, 0, 0.4);
`;

const FullScreenDialogContent = styled.div`
	position: relative;
	overflow: hidden;
	width: 100vw;
	height: 100vh;
	max-width: 560px;
	transition: 0.3s;
	color: var(--color-on-surface);
	background: var(--color-surface);
`;

const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	height: 56px;
	padding-right: 24px;
	padding-left: 16px;
	gap: 16px;

	h2 {
		flex: 1 1 auto;
		font-style: var(--md-sys-typescale-label-large-font-family-style);
		font-weight: var(--md-sys-typescale-label-large-font-weight);
		font-size: var(--md-sys-typescale-label-large-font-size);
		letter-spacing: var(--md-sys-typescale-label-large-tracking);
		line-height: var(--md-sys-typescale-label-large-height);
		text-transform: var(--md-sys-typescale-label-large-text-transform);
		text-decoration: var(--md-sys-typescale-label-large-text-decoration);
	}
`;

const CloseButton = styled.span`
	position: relative;
	width: 24px;
	height: 24px;
	font-family: "Material Symbols Rounded" !important;
	font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 24;
	font-size: 24px;
	line-height: 24px;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	transition: 0.3s;
	z-index: 1;

	&::before {
		content: "";
		position: absolute;
		top: -6px;
		left: -6px;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: trasparent;
		transition: 0.3s;
		z-index: -1;
	}

	&:hover::before {
		background: var(--color-surface-container-highest);
	}
`;

const Body = styled.div`
	margin: 12px 24px 0;
	overflow: auto;
	max-height: calc(100vh - 56px - 24px);
`;

export default class FullScreenDialogComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			isDialogOpen: false,
			theme: props.theme || "var(--color-secondary)",
		};

		this.open = this.open.bind(this);
		this.close = this.close.bind(this);
	}

	open() {
		this.setState({ isOpen: true });
		setTimeout(() => {
			this.setState({ isDialogOpen: true });
		}, 10);
	}

	close() {
		this.setState({ isDialogOpen: false });
		setTimeout(() => {
			this.setState({ isOpen: false });
		}, 300);
	}

	render() {
		return this.state.isOpen
			? createPortal(
					<DialogContainer
						aria-modal="true"
						role="dialog"
						onClick={() => this.close()}
					>
						<FullScreenDialogContent
							isOpen={this.state.isDialogOpen}
							onClick={(e) => e.stopPropagation()}
						>
							<Header>
								<CloseButton
									title="Chiudi"
									onClick={() => this.close()}
								>
									close
								</CloseButton>
								<h2>{this.props.title}</h2>
								{this.props.actionButton && (
									<TextButton
										text={this.props.actionButton.text}
										onClick={
											this.props.actionButton.onClick
										}
									></TextButton>
								)}
							</Header>
							<Body>{this.props.children}</Body>
						</FullScreenDialogContent>
					</DialogContainer>,
					document.body
			  )
			: null;
	}
}

FullScreenDialogComponent.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.node,
	actionButton: PropTypes.shape({
		theme: PropTypes.string,
		text: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
	}),
};

FullScreenDialogComponent.defaultProps = {
	actionButton: null,
};
